import { PdfViewerProvider } from "@synthesis/pdf-viewer";
import { KeycloakAuth } from "@synthesis/shared-auth";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { handleZodError } from "@synthesis/shared-services";
import { NoticeCenter, Portal, SnackbarCenter } from "@synthesis/shared-ui";

import { GgeRouterProvider } from "./gge-router-provider";
import { WSNotificationsProvider } from "./hooks";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => handleZodError(error, `query ${JSON.stringify(query.queryKey)}`),
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => handleZodError(error, `mutation ${JSON.stringify(mutation.options.mutationKey)}`),
  }),
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
});

export const App = () => (
  <KeycloakAuth>
    <WSNotificationsProvider>
      <DndProvider backend={HTML5Backend}>
        <QueryClientProvider client={queryClient}>
          <PdfViewerProvider>
            <GgeRouterProvider />
            <Portal>
              <SnackbarCenter duration={3000} position="bottom-center" />
              <NoticeCenter />
            </Portal>
          </PdfViewerProvider>
        </QueryClientProvider>
      </DndProvider>
    </WSNotificationsProvider>
  </KeycloakAuth>
);
